// extracted by mini-css-extract-plugin
export var noSpinners = "_ol-6";
export var percentageInput = "_ol-7";
export var variantColor1 = "_ol-0";
export var variantColor2 = "_ol-1";
export var variantColor3 = "_ol-2";
export var variantColor4 = "_ol-3";
export var variantColor5 = "_ol-4";
export var variantColor6 = "_ol-5";